var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 497 497",
    height: 512,
    viewBox: "0 0 497 497",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m467 82.5h-30v90h60v-60c0-16.57-13.43-30-30-30z",
    fill: "#ffa436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 112.5-90 120h-377v-180c0-16.57 13.43-30 30-30h146.07c7.96 0 15.59 3.16 21.22 8.79l51.21 51.21h188.5c16.57 0 30 13.43 30 30z",
    fill: "#ffbc2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 112.5-60 75h90v-75z",
    fill: "#8ae7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 112.5v150l-407-120v-30z",
    fill: "#bdf2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 142.5h290.93v90h-290.93z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 142.5-30 30v302h30c16.57 0 30-13.43 30-30v-272c0-16.57-13.43-30-30-30z",
    fill: "#ffbc2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467 142.5v302c0 16.57-13.43 30-30 30h-407c-16.57 0-30-13.43-30-30v-212c0-16.57 13.43-30 30-30h218.5l51.21-51.21c5.63-5.63 13.26-8.79 21.22-8.79z",
    fill: "#ffcf66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.b52056ef33d306cdef39f72ae5b370b7.svg";
export { ForwardRef as ReactComponent };